import { postPurchaseFlowStepArraySchema } from "@redotech/redo-model/advanced-flow/advanced-flow-db-parser";
import * as z from "zod/v4";

export const getPostPurchaseFlowSteps = {
  name: "getPostPurchaseFlowSteps" as const,
  input: z.null(),
  output: z.object({ steps: postPurchaseFlowStepArraySchema }),
};
export type GetPostPurchaseFlowStepsOutput = z.infer<
  typeof getPostPurchaseFlowSteps.output
>;
